import { LDEngine } from './ld-engine.js';
import { createLvl1 } from './levels/lvl1.js';
import { setup_systems } from './setup-systems.js';
import { loop } from './utils/update-loop.js';
import { initDebug } from './utils/debug.js';


const world = new LDEngine();
initDebug(world);

setup_systems(world);


createLvl1(world);



loop((dt) => world.update(dt / 1000));



